import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AdminAccessService } from "./admin-access.service";

/**
 * Admin-side route gate. `data.module` names a key from the module catalogue;
 * a route with no key is open to every administrator (Change Password).
 */
@Injectable({ providedIn: "root" })
export class ModuleGuard implements CanActivate {
  constructor(private access: AdminAccessService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (localStorage.getItem("roleId") !== "1") {
      this.router.navigate(["/login"]);
      return false;
    }

    const key: string = route.data ? route.data.module : null;
    if (!key || this.access.can(key)) return true;

    this.router.navigate(["/admin/no-access"]);
    return false;
  }
}
